<template>
    <div class="container">
        <h1 class="mt-2 mb-4">Password Reset</h1>
        <div class="pb-20 h-screen w-full md:w-1/2">

            <form method="POST" aria-label="Forgot Password" @submit.prevent="validateBeforeSubmit">
                <div v-bind:class="{'mb-8 text-left': true, 'has-error': errors.has('email')}">
                    <label for="email" class="text-h3 font-sans-bold" ref="email">Email Address</label>
                    <input id="email" type="email" name="email" v-model="email" v-validate="'required'">
                    <span v-show="errors.has('email')" class="error text-error-red text-lg">{{ errors.first('email') }}</span>
                </div>

                <div v-bind:class="{'mb-8 text-left': true, 'has-error': errors.has('password')}">
                    <label for="password" class="text-h3 font-sans-bold" ref="password">
                        Password
                        <div class="text-sm font-sans-book">
                            <span class="font-sans-bold">Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number.</span>
                        </div>
                    </label>
                    <input id="password" v-model="password" type="password" name="password" ref="passwordInput"
                        v-validate="'required|min:8|upperCase|number|lowerCase'" >
                    <span v-show="errors.has('password')" class="error text-error-red text-lg">{{ errors.first('password') }}</span>
                </div>

                <div v-bind:class="{'mb-8 text-left': true, 'has-error': errors.has('password_confirmation')}">
                    <label for="email" class="text-h3 font-sans-bold" ref="password_confirmation">Confirm Password</label>
                    <input id="password" type="password" name="password_confirmation"
                        v-validate="'required|confirmed:passwordInput'">
                    <span v-show="errors.has('password_confirmation')" class="error text-error-red text-lg">{{ errors.first('password_confirmation') }}</span>
                </div>

                <div class="text-left">
                    <button type="submit" class="button">
                        Reset my password
                    </button>
                </div>
            </form>
        </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import validation from "../../mixins/validation";

    export default {
        mixins: [validation],
        data() {
            return {
                email: null,
                password: null
            };
        },
        methods: {
            validateBeforeSubmit: function() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.gotoFirstValidationError();
                        return;
                    }

                    let data = {
                        token: this.$route.params.token,
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password
                    };

                    axios
                        .post(this.$laroute.route("password.request"), data)
                        .then(resp => {
                            this.$toasted.show("Password reset");
                            this.$router.push("/");
                        })
                        .catch(e => {
                            if (e.response.data.errors) {
                                _.forEach(e.response.data.errors, (message, id) => {
                                    const field = this.$validator.fields.find({
                                        name: id,
                                        scope: this.$options.scope
                                    });
                                    this.$validator.errors.add({
                                        id: field.id,
                                        field: id,
                                        msg: message[0],
                                        scope: this.$options.scope
                                    });
                                });
                            }
                        });
                });
            }
        }
    };
</script>
